const CAMPAIGN_ID = '120256162987260397';
const CAMPAIGN_NAME = 'Lead Campaign website - NT- BLR | DLH | BOM';

// Tags can arrive with a placement source (fb, ig, wa) or a legacy campaign ID
// in utm_source. This identifies campaign-tagged traffic, not paid clicks.
export function isMetaCampaignTaggedVisit(params: URLSearchParams): boolean {
  const campaign = params.get('utm_campaign');
  return campaign === CAMPAIGN_ID || campaign === CAMPAIGN_NAME ||
    params.get('utm_source') === CAMPAIGN_ID;
}
